import {
  Block,
  Card,
  ListItem,
  Title,
  Filters,
  VirtualList,
  FilterDef,
  useRowsData,
  ListHeader,

} from "@mc/ui-v4";
import React from "react";
import {
  DruhPripaduVO,
  FilterVO,
  InstanceSouduVO,
  OrgJednotkaVO,
  SoudniSporyApi,
  SoudVO,
  StavSporuVO,
  TypSporuVO,
  VysledekSporuVO,

} from "../api";
import { useQuery } from "react-query";
import { WaitForQueryData } from "@mc/react-app-v4";
import { BaseLayoutWrapper } from "../components/BaseLayoutWrapper";
import { SoudniSpisSeznamItem } from "../components/SoudniSpisSeznamItem";
import { useHistory } from "react-router";
import {
  DRUHSPORU,
  INSTANCESOUDU,
  ORGJEDNOTKA,
  ROKY,
  SOUDY,
  STAVSPORU,
  TYPSPORU,
  VYSLEDKYSPORU,
} from "../queryKeys";
import { getZastoupeniItems } from "../captions/Zastoupeni";
import { getKeKontroleItems } from "../captions/KeKontroleCaption";

export const VyhledavaniPage: React.FC = () => {
  const typSporuQuery = useQuery<TypSporuVO[]>(
    [TYPSPORU],
    async () => (await SoudniSporyApi.getTypySporu()).data
  );
  const druhSporuQuery = useQuery<DruhPripaduVO[]>(
    [DRUHSPORU],
    async () => (await SoudniSporyApi.getDruhyPripadu()).data
  );
  const rokyQuery = useQuery<number[]>(
    [ROKY],
    async () => (await SoudniSporyApi.getRekapitulaceRoky()).data
  );
  const orgJednotkaQuery = useQuery<OrgJednotkaVO[]>(
    [ORGJEDNOTKA],
    async () => (await SoudniSporyApi.getOrgJednotky()).data
  );
  const stavSporuQuery = useQuery<StavSporuVO[]>(
    [STAVSPORU],
    async () => (await SoudniSporyApi.getStavySporu()).data
  );
  const soudyQuery = useQuery<SoudVO[]>(
    [SOUDY],
    async () => (await SoudniSporyApi.getSoudy()).data
  );
  const vysledkySporuQuery = useQuery<VysledekSporuVO[]>(
    [VYSLEDKYSPORU],
    async () => (await SoudniSporyApi.getVysledkySporu()).data
  );
  const instanceSouduQuery = useQuery<InstanceSouduVO[]>(
    [INSTANCESOUDU],
    async () => (await SoudniSporyApi.getInstanceSoudu()).data
  );

  const filtersDef: FilterDef[] = React.useMemo(() => {
    return [
      {
        size: 300,
        name: "fulltext",
        label: "Rychlé hledání",
        type: "text",
      },
      {
        name: "idProtistrana",
        label: "Subjekt (protistrana sporu)",
        type: "autocomplete",
        size: 40,
        autocompleteProps: {
          onSearchItems: async (value) => {
            const data = await SoudniSporyApi.findProtistrana(value);
            return data.data.map((item) => ({
              id: item.idPartner,
              name: item.uplnaIdentifikace,
            }));
          },
        },
      },
      {
        name: "keKontrole",
        label: "Ke kontrole",
        type: "selectBox",
        selectBoxProps: {
          items: getKeKontroleItems(),
        },
      },
      {
        name: "rok",
        type: "selectBox",
        label: "Rok",
        selectBoxProps: {
          items: rokyQuery.data?.filter(Number)?.map((item) => ({
            id: item,
            name: item?.toString(),
          })),
        },
      },
      {
        name: "idTypSporu",
        type: "selectBox",
        label: "Typ sporu",
        selectBoxProps: {
          items: typSporuQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        name: "idDruhSporu",
        type: "selectBox",
        label: "Druh sporu",
        selectBoxProps: {
          items: druhSporuQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        name: "idStavSporu",
        type: "selectBox",
        label: "Stav sporu",
        selectBoxProps: {
          items: stavSporuQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        name: "idVysledekSporu",
        type: "selectBox",
        label: "Výsledek sporu",
        selectBoxProps: {
          items: vysledkySporuQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        name: "spisovaZnacka",
        type: "text",
        label: "Spisová značka",
      },
      {
        name: "idOjVlastnik",
        type: "selectBox",
        label: "Vlastník případu (OJ)",
        selectBoxProps: {
          items: orgJednotkaQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        name: "zastoupeni",
        type: "selectBox",
        label: "Zastoupení",
        selectBoxProps: {
          items: getZastoupeniItems(),
        },
      },
      {
        name: "idSoud",
        type: "selectBox",
        label: "Soud",
        selectBoxProps: {
          items: soudyQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        name: "idInstance",
        type: "selectBox",
        label: "Instance soudu",
        selectBoxProps: {
          items: instanceSouduQuery?.data?.map((item) => ({
            id: item.id,
            name: item.nazev,
          })),
        },
      },
      {
        size: 30,
        name: "znacka",
        type: "text",
        label: "Soudní značka",
      },
    ];
  }, [
    typSporuQuery.data,
    druhSporuQuery.data,
    stavSporuQuery.data,
    vysledkySporuQuery.data,
    orgJednotkaQuery.data,
    soudyQuery.data,
    instanceSouduQuery.data,
    rokyQuery.data,
  ]);

  const History = useHistory();
  const rowsData = useRowsData<FilterVO>("vysledky", {
    initialVisibleFields: [
      "fulltext",
      "idProtistrana",
      "rok",
      "idTypSporu",
      "idDruhSporu",
      "idStavSporu",
      "idVysledekSporu",
      "spisovaZnacka",
      "idOjVlastnik",
      "zastoupeni",
      "idSoud",
      "idInstance",
      "znacka",
    ],
    initialFilter: {
      source: "urlSearch",
      filterType: "onlyValues",
      filterDefs: filtersDef,
    },
  });
  const response = rowsData.filter.queryFilter;
  const seznamQuery = useQuery<number[]>(
    ["seznam-query", rowsData.filter.queryFilter, rowsData.rows.sort],
    async () => (await SoudniSporyApi.vyhledatSoudniSporyIds(response)).data,
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retryOnMount: false,
    }
  );
  return (
    <BaseLayoutWrapper currentKey={"seznam-sporu"}>
      <div className={"w-100 h-100 d-flex flex-column pr-2 px-4 py-2"}>
        <Title level={1}>Vyhledávání soudních sporů</Title>
        <WaitForQueryData
          showContentWhenLoading
          queries={[
            seznamQuery,
            typSporuQuery,
            druhSporuQuery,
            rokyQuery,
            orgJednotkaQuery,
            stavSporuQuery,
            soudyQuery,
            vysledkySporuQuery,
            instanceSouduQuery,
          ]}
        >
          {() => {
            return (
              <div className={"d-flex flex-column h-100 w-100"}>
                <Card className={"my-4"} mode={"edit"}>
                  <Block>
                    <Filters<FilterVO>
                      {...rowsData.filter}
                      filtersDef={filtersDef}
                      type={"onlyValues"}
                    />
                  </Block>
                </Card>
                <div style={{ flex: "1" }}>
                  <VirtualList
                    header={({ headerProps, checkedIds }) => {
                      return <ListHeader {...headerProps} />;
                    }}
                    ids={seznamQuery.data}
                    rowHeight={108}
                    getItemId={(item) => item.idPripad}
                    totalElements={seznamQuery.data?.length}
                    api={async (request) => {
                      const res = (
                        await SoudniSporyApi.getSoudniSporyByIds(
                          request.idsRequest.ids
                        )
                      ).data;
                      return {
                        rows: res,
                        totalElements: res.length,
                      };
                    }}
                  >
                    {({ row, listItemProps }) => {
                      return (
                        <ListItem
                          {...listItemProps}
                          onClick={() =>
                            History.push(
                              `/soudni-spory/detail?id=${row.idPripad}`
                            )
                          }
                        >
                          {row ? (
                            <SoudniSpisSeznamItem soudniSpor={row} />
                          ) : (
                            <div>Item nenalzeen</div>
                          )}
                        </ListItem>
                      );
                    }}
                  </VirtualList>
                </div>
              </div>
            );
          }}
        </WaitForQueryData>
      </div>
    </BaseLayoutWrapper>
  );
};
